<template>
  <div id="testimonial-description" class="testimonial-description">
    <b-container>
      <b-row class="blue_color">
        <b-col lg="7" md="12" sm="12">
          <lazy-component>
          <b-embed
            type="video"
            aspect="16by9"
            id="videos"
            class="video"
            controls
            :poster="require(`@/assets/img/video-thumbnails/${customerExperience.thumbnail}`)"
          >
            <source
              :src="require(`@/assets/videos/${customerExperience.customerVideo}`)"
              type="video/mp4"
            />
          </b-embed>
          </lazy-component>
        </b-col>
        <b-col lg="5" md="12" sm="12" class="right-section">
          <p class="text-title">{{customerExperience.heading}}</p>
          <p class="text-desc text-description">
            <span
              class="text-desc"
              v-if="!readMoreActivated"
            >{{customerExperience.description.slice(0, 200)}}</span>

            <span
              class="text-desc btn-link"
              v-if="!readMoreActivated"
              @click="activateReadMore"
            >  Read more...</span>

            <span
              class="text-desc"
              v-if="readMoreActivated"
              v-html="customerExperience.description"
            ></span>
            <span
              class="text-desc btn-link"
              v-if="readMoreActivated"
              @click="activateReadMore"
            >  Read less...</span>
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "Testimonialdescription",
  props: ["customerExperience"],
  data() {
    return {
      readMoreActivated: false,
    };
  },
  methods: {
    activateReadMore() {
      this.readMoreActivated = !this.readMoreActivated;
    },
  },
};
</script>
<style scoped>
.blue_color {
  color: var(--mainBlueColor);
}
.text-subtitle {
  text-align: left;
  font-size: 1rem;
  font-weight: 600;
}
.text-desc {
  font-size: 0.9rem;
  text-align: justify;
  font-weight: 400;
  margin-top: 2rem;
  margin-bottom: 0;
}
.text-title {
  text-align: left;
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 0;
}
.video {
  height: 90% !important;
  width: 90% !important;
}

/* Media Queries */
/* Tablet Screens */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .text-desc {
    font-size: 0.9rem;
    text-align: justify;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 0;
  }
  .video {
    height: 90% !important;
    width: 90% !important;
    margin: auto 0 auto 15px;
  }
  .right-section {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
}
/* Mobile Screens */
@media (min-width: 481px) and (max-width: 767px) {
  .right-section {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .video {
    height: 100% !important;
    width: 100% !important;
  }
  .text-desc {
    font-size:0.8rem;
    margin-top: 0;
  }
  .text-title {
    font-size:1.1rem;
    height: 100px;
  }
}
@media (max-width: 480px) {
  .right-section {
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
  .video {
    height: 100% !important;
    width: 100% !important;
  }
  .text-desc {
    font-size:0.8rem;
    margin-top: 0;
  }
  .text-title {
    font-size:1.1rem;
    height: 120px;
  }
  .text-description{
    padding-bottom:16px;
  }
  
}
</style>
